import { render, staticRenderFns } from "./TeamareaStatTable.vue?vue&type=template&id=6b0a2774&"
import script from "./TeamareaStatTable.vue?vue&type=script&lang=ts&"
export * from "./TeamareaStatTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports